// Bump when the nested artwork changes, so browsers drop their cached copies
export const EU_GARAN_NESTED_VERSION = 2;

export const EU_GARAN_MIN_YEARS = 1;
export const EU_GARAN_MAX_YEARS = 99;
